import axios from 'axios';

const API = axios.create({
    baseURL: 'https://www.dhimanwoodworks.com/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization'
    },
    withCredentials: true
});

API.interceptors.request.use((req) => {
    const token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

// Add response interceptor for debugging
API.interceptors.response.use(
    response => response,
    error => {
        console.log('Request URL:', error.config.url);
        console.log('Response Status:', error.response?.status);
        console.log('Response Data:', error.response?.data);
        return Promise.reject(error);
    }
);

export default API;
